<template>
  <div>
    <div class="title-device-item">
      <div class="title-name">{{pageTitle}}</div>
      <div class="title-center" v-if="!hideDeviceChange" :class="{'left1' : !hideDeviceChange}">
        <el-tooltip
            :open-delay="delayTime"
            effect="dark"
            content="PC端"
            placement="bottom"
        >
          <span
              :class="[
              deviceActive === 0
                ? 'active control-button-device control-button'
                : 'control-button-device control-button'
            ]"
              class="icon-portal-computer2"
              @click="switchDevice(0)"
          ></span>
        </el-tooltip>
        <el-tooltip :open-delay="delayTime" effect="dark" content="移动端" placement="bottom">
          <span
              :class="[
              deviceActive === 1
                ? 'active control-button-device control-button'
                : 'control-button-device control-button'
            ]"
              class="icon-portal-phone2"
              @click="switchDevice(1)"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <div class="content-box" :class="{'pc-box': isPcIframe}">
      <div class="html-container" :class="{'left1' : !hideDeviceChange, 'pc-container': isPcIframe}">
        <div class="title-box flex">
          <span class="icon-portal-close" style="width: 22px"></span>
          <span class="title-name flex1">{{ pageTitle }}</span>
          <span style="width: 22px">...</span>
        </div>
        <div v-if="!isPcIframe" class="phone-content" id="phoneContent" :class="{'fullScreen-phone':isPhoneFullScreen}">
          <iframe
              id="mh-v2-iframe"
              v-if="previewSrc"
              :class="isPhoneFullScreen ? 'width100' : ''"
              :src="previewSrc"
              frameborder="0"
              width="100%"
              height="100%"
              scrolling="no"
          ></iframe>
        </div>
        <div v-if="isPcIframe" class="pc-content">
          <iframe
              id="mh-v2-iframe-pc"
              v-if="previewSrc"
              :src="previewSrc"
              frameborder="0"
              width="100%"
              height="100%"
          ></iframe>
        </div>
      </div>
      <div class="page-container" v-if="isPhoneFullScreen">
        <el-button style="display: none;" class="page-button" @click="pageHandle('prev')" :loading="loading" :disabled="prevDisabled"
        >上一页</el-button
        >
        <el-tooltip :open-delay="delayTime" effect="dark" content="上一页" placement="right">
          <el-button class="page-button icon-portal-arrows-up" @click="pageHandle('prev')" :loading="loading" :disabled="prevDisabled"></el-button>
        </el-tooltip>
        <el-input-number
            class="page-num-button"
            v-model="pageNum"
            :controls="false"
            :min="1"
            :max="pageSize"
            size="large"
            :disabled="true"
        ></el-input-number>
        <el-button style="display: none;" class="page-button" @click="pageHandle('next')" :loading="loading" :disabled="nextDisabled"
        >下一页</el-button
        >
        <el-tooltip :open-delay="delayTime" effect="dark" content="下一页" placement="right">
          <el-button class="page-button icon-portal-arrows-down" @click="pageHandle('next')" :loading="loading" :disabled="nextDisabled"></el-button>
        </el-tooltip>
        <el-tooltip :open-delay="delayTime" effect="dark" content="预览动画" placement="right">
          <el-button class="page-button icon-portal-play" @click="pageHandle('play')" :loading="loading"></el-button>
        </el-tooltip>
      </div>
      <div class="preview-right-toolbar" v-if="!isPcIframe">
        <h3 class="title" style="display: none;">分享</h3>
        <div class="preview-right-content">
          <h4 class="fs14 mb16" style="display: none;">扫码分享 <span class="fs12">支持微信、QQ、浏览器等APP扫码</span></h4>
          <h4 class="fs14 mb16 font600">移动端预览</h4>
          <div id="qrcode"></div>
          <h4 class="fs12 mb16 col0004">支持微信、QQ、浏览器等APP扫码</h4>
          <h4 class="fs14 mb16" style="display: none;">其他分享方式</h4>
          <div class="previewSrc-inp-wrap">
            <input id="previewSrcInp" class="previewSrc-inp" type="text" readonly :value="showPreviewSrc" />
            <el-button class="copy-btn" type="primary" @click="copyLink">复制链接</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/common.css"
import "../assets/icomoon/style.css"
import QRCode from "qrcodejs2"
import { GetRequest, initAppStageData, judgeIsMobile } from "../utils/initUrlQueryData"
import { _debounce, _throttle } from "../utils"
export default {
  name: "ssr_preview",
  data() {
    return {
      previewSrc: "",
      pageTitle: "",
      phoneHtml: "",
      qrcode: undefined,
      protocol: "",
      showPreviewSrc: "",
      isPhoneFullScreen: false,
      showNextButton: false,
      noHiddenPage: false,
      loading: true,
      pageNum: 1,
      pageSize: 1,
      delayTime: 1000,
      isOnlyH5Template: false,
      isPcIframe: false,
      pcPreviewSrc: "",
      deviceActive: 1, //pc端和移动端选中值 0，pc端  1，移动端
      pageId: "", //页面的pageId
      isSubPage: false, //判断是否是子页面listPage，detailPage
      hideDeviceChange: false,  //是否隐藏切换双端按钮
    }
  },
  computed: {
    prevDisabled() {
      return this.pageNum === 1
    },
    nextDisabled() {
      return this.pageNum === this.pageSize
    },
  },
  created() {
    top.addEventListener("message", this.listenData)
  },
  mounted() {
    let urlParam = GetRequest()
    const self = this
    if (urlParam.p) {
      this.pageId = urlParam.p
      // 从网站列表 进来的预览
      this.webListScan(urlParam.p)
    } else {
      // 从编辑页进来的预览
      this.getScanInfo()
    }
    // 判断当前页面在iframe里，则重定向到预览地址
    if (window.frames.length != window.parent.frames.length) {
      window.location.href = this.previewSrc
    }
    this.generateQrcode()
    document.getElementsByClassName("loading-box")[0].style.display = "none"
  },
  beforeDestroy() {
    top.removeEventListener("message", this.listenData)
  },
  methods: {
    hideLoading: _debounce(function () {
      this.loading = false
    }, 800),
    pageHandle: _throttle(function (type) {
      const ssrIframe = document.getElementById("mh-v2-iframe")
      if(type === "play"){
        this.pageNum = 1
      }
      ssrIframe && ssrIframe.contentWindow.postMessage({ type, data: this.pageNum }, "*")
    }, 500),
    async webListScan(pageId) {
      this.previewSrc = window.location.origin + `/v2/p/${pageId}`
      this.showPreviewSrc = this.previewSrc
      this.previewSrc = `${this.previewSrc}?mh-v2-iframe=1`
      /* 纯移动端判断 */
      let res = await judgeIsMobile(pageId)
      if(res.data.code === 1){
        let resData = res.data.data
        if (resData.isPhoneFullScreen) {
          this.isPhoneFullScreen = resData.isPhoneFullScreen
          this.deviceActive = 1
        }
        if(resData.isOnlyH5Template){
          this.isOnlyH5Template = resData.isOnlyH5Template
          this.deviceActive = 1
        }
      }
      if(this.isPhoneFullScreen || this.isOnlyH5Template){
        this.hideDeviceChange = true
      }else{
        this.hideDeviceChange = false
      }
    },
    getScanInfo() {
      let params = JSON.parse(localStorage.getItem("routerParams"))
      if (params.hasOwnProperty("appId")){
        this.isSubPage = true
      }
      this.previewSrc = params.link
      this.isPhoneFullScreen = params.isPhoneFullScreen
      this.isOnlyH5Template = params.isOnlyH5Template
      if(this.isPhoneFullScreen || this.isOnlyH5Template){
        this.hideDeviceChange = true
      }else{
        this.hideDeviceChange = false
      }
      if (this.previewSrc.indexOf("http") > -1) {
        this.previewSrc = this.previewSrc.split(":")[1]
      }
      this.protocol = window.location.protocol
      this.showPreviewSrc = this.protocol + this.previewSrc
      this.previewSrc =
          this.previewSrc.indexOf("?") > -1 ? `${this.previewSrc}&mh-v2-iframe=1` : `${this.previewSrc}?mh-v2-iframe=1`
      this.pageTitle = params.title
      window.document.title = this.pageTitle
    //  判断是否双端，获取pc端页面地址
      if (!this.hideDeviceChange) {
        this.deviceActive = 1
        if(this.previewSrc.indexOf("&mh-v2-iframe=1") > -1){
          this.pcPreviewSrc = this.previewSrc.split("&mh-v2-iframe=1")[0]
        }else if(this.previewSrc.indexOf("?mh-v2-iframe=1") > -1){
          this.pcPreviewSrc = this.previewSrc.split("?mh-v2-iframe=1")[0]
        }
        if(this.previewSrc.indexOf("&a=1") > -1){
          this.pcPreviewSrc = this.previewSrc.split("&a=1")[0]
        }
        sessionStorage.setItem("request_prefix", "appStage")
      }
    },
    generateQrcode() {
      this.qrcode = new QRCode("qrcode", {
        width: 132,
        height: 132,
        text: this.showPreviewSrc // 二维码地址
      })
    },
    copyLink() {
      let target = null
      target = document.querySelector("#previewSrcInp")
      target.select()
      let copyResult = document.execCommand("copy")
      window.getSelection().removeAllRanges()
      if (copyResult) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "复制成功",
          type: "success"
        })
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "复制失败",
          type: "error"
        })
      }
    },
    listenData(e) {
      if (e.data === "removeStage") {
        this.loading = true
        this.hideLoading()
      }
      if (e.data.type === "initPage") {
        this.pageSize = e.data.data
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 1500)
      }
      if (e.data === "initRemoveStage") {
        this.loading = true
        this.hideLoading()
      }
      if (e.data.type === "updatePageNum") {
        this.pageNum = e.data.data
      }
      if (e.data.type === "updatePageSize") {
        this.pageSize = e.data.data
      }
    },
    async switchDevice(index) {
      if (this.request_prefix === "stage" && index === 0) {
        return
      }
      if (this.request_prefix === "appStage" && index === 1) {
        return
      }
      this.deviceActive = index
      this.previewSrc = ""
      if(index === 0){
        //切换到pc端
        this.request_prefix = "stage"
        this.isPcIframe = true
        this.previewSrc = this.pcPreviewSrc
        sessionStorage.setItem("request_prefix", "stage")
      }else{
        //切换到移动端
        this.request_prefix = "appStage"
        this.isPcIframe = false
        sessionStorage.setItem("request_prefix", "appStage")
        this.$nextTick(()=>{
          if(this.pageId){
            // 从网站列表 进来的预览
            this.webListScan(this.pageId)
          }else{
            // 从编辑页进来的预览
            this.getScanInfo()
            this.generateQrcode()
          }
        })
      }
    },
  }
}
</script>
<style>
::-webkit-scrollbar{
  width: 0;
}
</style>
<style scoped lang="scss">

  #mh-v2-iframe {
    //width: calc(100% + 15px);
  }
  #mh-v2-iframe.width100 {
    width: 100%;
  }
  .page-container {
    position: absolute;
    /*bottom: 40px;*/
    /*width: 100%;*/
    /*display: flex;*/
    justify-content: center;

    top: 100px;
    left: calc(50% + 212px - 160px);
    bottom: auto;
    width: auto;
    display: grid;

    .page-num-button {
      width: 80px;
      height: 38px;
      padding: 0 6px;
      display: none;
      ::v-deep &.el-input-number.is-without-controls .el-input__inner {
        height: 38px;
        border: 1px solid #dcdfe6;
        background: #fff;
        color: #000 !important;
      }
    }
  }
  .page-container .page-button {
    /*border: 1px solid #dcdfe6;*/
    /*background: #fff;*/
    /*color: #000;*/
    color: rgba(0, 0, 0, 0.6);
    margin: 6px;
    border: 0;
    background: transparent;
  }
  .page-container .page-button:active {
    color: #3a8ee6;
    border-color: #3a8ee6;
    outline: none;
  }
  .html-container {
    position: absolute;
    /*top: 50%;*/
    /*left: 50%;*/
    /*transform: translate(-50%, -50%);*/
    /*background: url("../assets/images/phone1.png");*/
    background-size: 100% 100%;
    /*width: 491px;*/
    /*height: 895px;*/
    /*padding: 73px 39px 13px;*/
    /*border-radius: 50px;*/
    top: 0;
    /*left: 50%;*/
    left: calc(50% - 160px);
    transform: translateX(-50%);
    width: 414px;
    height: 100%;
    padding: 0;
    border-radius: 0;
    &.left1{
      left: 50%;
    }
    &.pc-container{
      width: 100%;
      .pc-content{
        height: 100%;
      }
    }
  }
  .title-box {
    /*display: flex;*/
    padding: 8px 10px;
    line-height: 22px;
    font-size: 14px;
    background-color: #ededed;
    text-align: center;
    display: none;
  }
  .flex1 {
    flex: 1;
  }
  .phone-content {
    /*height: 736px;*/
    border: 1px solid #ededed;
    /*border-radius: 0 0 38px 38px;*/
    overflow: hidden;
    border-radius: 0;
    height: 100%;
    &.fullScreen-phone{
      position: absolute;
      width: 100%;
      top: 50%;
      transform: translateY(-50%);
      height: 762px;
    }
  }
  .preview-right-toolbar {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 320px;
    background-color: #fff;
  }
  .preview-right-toolbar {
    color: var(--text);
  }
  .preview-right-toolbar .title {
    background-color: var(--elTreeHoverColor);
    padding: 13px 20px;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 22px;
  }
  .preview-right-content {
    padding: 16px 20px;
    box-sizing: border-box;
  }
  #qrcode {
    /*margin-bottom: 40px;*/
    margin-bottom: 16px;
  }
  .previewSrc-inp {
    width: 100%;
    background: #f0f0f0;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 32px;
    padding: 0 100px 0 12px;
    box-sizing: border-box;
  }
  .previewSrc-inp-wrap {
    position: relative;
  }
  .previewSrc-inp-wrap .copy-btn {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: var(--themeColor);
    border-radius: 0 4px 4px 0;
    font-size: 14px;
    line-height: 32px;
    padding: 0;
    text-align: center;
    width: 88px;
    color: #ffffff;
  }
.title-device-item{
  position: relative;
  height: 53px;
  background: white;
  border-bottom: 1px solid rgba(240, 240, 240, 1);
  .title-name {
    position: absolute;
    left: 24px;
    font-size: 16px;
    font-weight: 600;
    line-height: 54px;
    text-align: left;
  }
  .title-center {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    display: flex;
    .left1{
      left: calc(50% - 160px);
    }
  }
  .control-button{
    font-size: 24px;
    min-width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.active{
      background-color: var(--topOperationIconBgColor);
      color: var(--elTreeActiveColor);
    }
  }
}
.content-box{
  position: absolute;
  width: 100%;
  top: 54px;
  height: calc(100% - 54px);
  &.pc-box{
    height: calc(100% - 58px);
  }
}
.col0004{
  color: rgba(0, 0, 0, 0.4);
}
</style>
<style>
  @media screen and (max-width:600px) {
    .preview-right-toolbar {
      display: none;
    }
  }
</style>
